// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1azQ6","wrapper-nopadding":"wrapper-nopadding__18G1e","loading":"loading__2E1c6","error":"error__31vkX","table-loading":"table-loading__1ZBFo","empty-val":"empty-val__35Qjf","panelheader-tools":"panelheader-tools__2ew0f","propsPanels":"propsPanels__1Ftml","new":"new__1dTP9","marginLm":"marginLm__3Unqo","marginRm":"marginRm__uWiwk","fullWidth":"fullWidth__172uL","fullHeight":"fullHeight__1HUVZ","noData":"noData__1Q5Zv","editor":"editor__DQ5Vx","scriptEditor":"scriptEditor__2PV6t","submit":"submit__2stgT"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/FlowsView/coms/AddFlow/styles.scss
// module id = 2209
// module chunks = 1